<template>
  <v-container fluid>
    <v-row>
      <v-col v-for="card in cards" :key="card.title" cols="12" md="4">
        <v-card min-height="244" outlined class="pa-3">
          <v-list-item three-line>
            <v-list-item-content>
              <div class="caption mb-4 font-regular">STAGE {{ card.step }}</div>
              <v-list-item-title class="headline my-3" v-text="card.title" />
              <span class="font-weight-light subtitle-1">
                {{ card.desc }}
              </span>
              <div class="d-flex justify-end">
                <v-btn
                  class="mt-3 "
                  color="primary"
                  :to="project + card.to"
                  v-text="card.btn"
                />
              </div>

              <!--             <v-card-text>
              <div class="headline mb-2">Unlimited music now</div>
              Listen to your favorite artists and albums whenever and wherever, online and offline.
            </v-card-text> -->
            </v-list-item-content>

            <!-- <v-list-item-avatar
            tile
            size="80"
            color="grey"
          ></v-list-item-avatar> -->
          </v-list-item>
        </v-card>
        <v-list-item three-line>
          <v-list-item-content> </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {},
  data: function() {
    return {
      project: null,
      cards: [
        {
          step: 1,
          title: "Connect you Data",
          desc:
            "Enable your data accross your organization. A single hub to manage all your data integration.",
          btn: "Add Dataset",
          to: "/create/dataset"
        },
        {
          step: 2,
          title: "Get Insight",
          desc:
            "Undestand your Data and discover how to create your first Dashboard with in a few minutes.",
          btn: "Add Query",
          to: "/create/query"
        },
        {
          step: 3,
          title: "Play",
          desc:
            "Make development easy, write business logix on the fly, publish and manage app in minutes.",
          btn: "Add Function",
          to: "/create/function"
        }
      ]
    };
  },
  mounted: function() {
    this.project = this.$route.params.project;
  },
  methods: {}
};
</script>
